<template>
  <div class="wrap">
    <el-input 
      type="textarea" 
      class="area" 
      v-model="inputValue" 
      :placeholder="placeholder1"
      :minlength="min"
      :maxlength="max"
      v-bind="$attrs"
      v-on="$listeners"
      @focus="inputFocus"
      @blur="inputBlur">
    </el-input>
    <label class="title" :class="change">
      <span v-if="isImportant" class="important">*</span>
      <span>{{placeholder}}</span>
    </label>
  </div>
</template>

<script>
// 获取这个组件的输入数据，在调用的地方传入 @getdata=“xxxxx”  这个函数会返回输入域的输入，每次组件失焦的时候会自动更新
export default {
  data() {
    return {
      change: '',
    }
  },

  props: {
    value: {},

    placeholder: {
      type: String,
      default: '请输入'
    },

    isLabel: {
      type: Boolean,
      default: true
    },

    isImportant: {
      type: Boolean,
      default: true
    },

    min: {
      type: String,
      default: '0'
    },

    max: {
      type: String,
      default: '1000'
    }
  },

  methods: {
    inputFocus() {
      this.change = 'focus'
    },

    inputBlur() {
      if (this.value !== '') {
        this.change = 'blur'
      } else {
        this.change = ''
      }
    }
  },

  computed: {
    placeholder1() {
      if (this.isLabel) {
        return ''
      }
      return this.placeholder
    },

    inputValue: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.wrap {
  position: relative;

  /deep/ .el-textarea > textarea {
    min-height: 88px!important;
  }
  /deep/ .el-textarea__inner {
    padding: 8px 15px;
  }

  .area {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: #333333;
  }

  .title {
    position: absolute;
    left: 13px;
    top: 16px;
    margin-top: -7px;
    padding: 2px 3px;
    font-size: 14px;
    transform-origin: 0 0;
    background: #fff;
    color: #c1c4cc;
    transition: all .25s;
    pointer-events: none;
  }

  .important {
    position: relative;
    top: 3px;
    margin-right: 2px;
    font-size: 16px;
    font-weight: bold;
    color: #E51C23;
  }

  .focus {
    font-size: 12px;
    color: #08A681;
    padding: 2px 3px;
    font-weight: bolder;
    letter-spacing: 0;
    line-height: 16px;
    transform: translate(-2px, -18px);
  }

  .blur {
    font-size: 12px;
    color: #666666;
    padding: 2px 3px;
    letter-spacing: 0;
    line-height: 16px;
    transform: translate(-2px, -18px);
  }
}
</style>
